var map = {
	"./_settings.scss": 1333,
	"./base/_alert-boxes.scss": 1334,
	"./base/_badges.scss": 1335,
	"./base/_base.scss": 1336,
	"./base/_cw-footer.scss": 1337,
	"./base/_fonts.scss": 1338,
	"./base/_forms.scss": 1339,
	"./base/_grid.scss": 1340,
	"./base/_layout.scss": 1341,
	"./base/_lightbox.scss": 1342,
	"./base/_modal.scss": 1343,
	"./base/_nav-bar.scss": 1344,
	"./base/_normal_font.scss": 117,
	"./base/_offcanvas.scss": 1345,
	"./base/_pagination.scss": 1346,
	"./base/_panels.scss": 1347,
	"./base/_sharing.scss": 1348,
	"./base/_switches.scss": 1349,
	"./base/_tables.scss": 1350,
	"./base/_tooltips.scss": 1351,
	"./base/_type.scss": 1352,
	"./base/_video.scss": 1353,
	"./base/_visibility.scss": 1354,
	"./base/buttons/_all.scss": 1355,
	"./base/buttons/_mixins.scss": 1356,
	"./base/buttons/_sharing.scss": 1357,
	"./base/forms/_checkboxes.scss": 1358,
	"./base/forms/_input-combos.scss": 1359,
	"./base/forms/_non-text.scss": 1360,
	"./base/forms/_text-fields.scss": 1361,
	"./base/nav-bar/_base-with-links.scss": 1362,
	"./base/nav-bar/_base.scss": 1363,
	"./base/nav-bar/_fade.scss": 1364,
	"./base/nav-bar/_inverted.scss": 1365,
	"./base/nav-bar/_large-up.scss": 1366,
	"./components/_hero.scss": 1367,
	"./pages/accounts.scss": 1368,
	"./pages/admin.scss": 1369,
	"./pages/admin/grants.scss": 1370,
	"./pages/admin/offline_donations.scss": 1371,
	"./pages/authorization.scss": 1372,
	"./pages/birthdays.scss": 1373,
	"./pages/campaigns.scss": 1374,
	"./pages/donations.scss": 1375,
	"./pages/donations/_donate-form.scss": 1376,
	"./pages/donations/_hidden-campaign.scss": 1377,
	"./pages/donations/_sponsor-recognition.scss": 1378,
	"./pages/donations/_thank-you.scss": 1379,
	"./pages/donations/components/_ach-popout-form.scss": 1380,
	"./pages/donations/components/_apple-pay-button.scss": 1381,
	"./pages/donations/components/_browser-fallback.scss": 1382,
	"./pages/donations/components/_donate-buttons.scss": 1383,
	"./pages/donations/components/_donate-by-check-modal.scss": 1384,
	"./pages/donations/components/_donation-form-inputs.scss": 1385,
	"./pages/donations/components/_gift_aid.scss": 1386,
	"./pages/donations/components/_iho.scss": 1387,
	"./pages/donations/components/_offscreen-donate-components.scss": 1388,
	"./pages/donations/components/_stripe-elements.scss": 1389,
	"./pages/donations/dynamic.scss": 1390,
	"./pages/donations/general.scss": 1391,
	"./pages/donations/gift-the-spring.scss": 1392,
	"./pages/donations/in-honor-of.scss": 1393,
	"./pages/donations/sponsor.scss": 1394,
	"./pages/donations/the-spring-new.scss": 1395,
	"./pages/donations/thespring.scss": 1396,
	"./pages/edit_mailing_list_subscriber.scss": 1397,
	"./pages/exceptions.scss": 1398,
	"./pages/founders.scss": 1399,
	"./pages/mailing-list-subscribers.scss": 1400,
	"./pages/partners.scss": 1401,
	"./pages/premium_impact_profile.scss": 1402,
	"./pages/profile/bps_membership.scss": 1403,
	"./pages/profile/lifetime_impact.scss": 1404,
	"./pages/profile/my_projects.scss": 1405,
	"./pages/profile/shared.scss": 1406,
	"./pages/profile/spring_membership.scss": 1407,
	"./pages/profile/user_private.scss": 1408,
	"./pages/profile/user_public.scss": 1409,
	"./pages/projects/_country_icons.scss": 1410,
	"./pages/projects/projects.scss": 1411,
	"./pages/redeem-the-spring.scss": 1412,
	"./pages/search.scss": 1413,
	"./pages/static_pages/about.scss": 1414,
	"./pages/static_pages/brand_partnerships.scss": 1415,
	"./pages/static_pages/company_match.scss": 1416,
	"./pages/static_pages/company_match_iframe.scss": 1417,
	"./pages/static_pages/completed_projects.scss": 1418,
	"./pages/static_pages/css_docs.scss": 1419,
	"./pages/static_pages/education.scss": 1420,
	"./pages/static_pages/error.scss": 1421,
	"./pages/static_pages/financials.scss": 1422,
	"./pages/static_pages/fundraise.scss": 1423,
	"./pages/static_pages/gala_dashboard.scss": 1424,
	"./pages/static_pages/get_involved.scss": 1425,
	"./pages/static_pages/home.scss": 1426,
	"./pages/static_pages/hundred_percent_model.scss": 1427,
	"./pages/static_pages/in_kind_donations.scss": 1428,
	"./pages/static_pages/internships.scss": 1429,
	"./pages/static_pages/jobs.scss": 1430,
	"./pages/static_pages/kids.scss": 1431,
	"./pages/static_pages/local_partners.scss": 1432,
	"./pages/static_pages/media.scss": 1433,
	"./pages/static_pages/mission.scss": 1434,
	"./pages/static_pages/our_approach.scss": 1435,
	"./pages/static_pages/our_projects.scss": 1436,
	"./pages/static_pages/our_work.scss": 1437,
	"./pages/static_pages/privacy.scss": 1438,
	"./pages/static_pages/scott_harrison_story.scss": 1439,
	"./pages/static_pages/scotts_story.scss": 1440,
	"./pages/static_pages/sensors.scss": 1441,
	"./pages/static_pages/staff.scss": 1442,
	"./pages/static_pages/the_pool.scss": 1443,
	"./pages/static_pages/volunteer.scss": 1444,
	"./pages/static_pages/water_crisis_learn.scss": 1445,
	"./pages/static_pages/whywater.scss": 1446,
	"./pages/stories.scss": 1447,
	"./pages/subscriptions.scss": 1448,
	"./pages/the_spring_series.scss": 1449,
	"./pages/thirst/thirst.scss": 1450,
	"./pages/uk/about.scss": 1451,
	"./pages/uk/partnerships.scss": 1452,
	"./pages/uk/privacy.scss": 1453,
	"./pages/uk/uk.scss": 1454,
	"./pages/unpledge.scss": 1455,
	"./pages/video_landing_page.scss": 1456,
	"./pages/wwd/community.scss": 1457,
	"./pages/wwd/discover.scss": 1458,
	"./pages/wwd/explore.scss": 1459,
	"./pages/wwd/profile.scss": 1460,
	"./pages/wwd/shared.scss": 1461,
	"./pages/wwd/welcome.scss": 1462,
	"./patterns/action-tiles.scss": 1463,
	"./patterns/avatar-initial.scss": 1464,
	"./patterns/cards.scss": 1465,
	"./patterns/clamp-for-ellipsis.scss": 1466,
	"./patterns/cw-icon-spin.scss": 1467,
	"./patterns/dashed-elements.scss": 1468,
	"./patterns/full-bottom-bg.scss": 1469,
	"./patterns/image-fill.scss": 1470,
	"./patterns/latest-update-indicator.scss": 1471,
	"./patterns/leading-image-block.scss": 1472,
	"./patterns/module.scss": 1473,
	"./patterns/progress.scss": 1474,
	"./patterns/side-by-side.scss": 1475,
	"./patterns/split-bg-block.scss": 1476,
	"./patterns/tabs.scss": 1477,
	"./patterns/text-separator.scss": 1478,
	"./patterns/yellow-underlined.scss": 1479,
	"./react-components/completed-projects-map.scss": 1480,
	"./react-components/email-capture-modal.scss": 1481,
	"./react-components/journey-player.scss": 1482,
	"./react-components/mailing-list-intercept-modal.scss": 1483,
	"./react-components/people-served-input.scss": 1484,
	"./settings/_colors.scss": 1485,
	"./settings/_general.scss": 1486,
	"./settings/_media-queries.scss": 1487,
	"./settings/_mixins.scss": 1488,
	"./settings/_type.scss": 1489,
	"./shared/breadcrumbs.scss": 1490,
	"./shared/clipboard-button.scss": 1491,
	"./shared/comments.scss": 1492,
	"./shared/cookie_banner.scss": 1493,
	"./shared/datepicker.scss": 1494,
	"./shared/fixed-banner.scss": 1495,
	"./shared/geosuggest.scss": 1496,
	"./shared/grecaptcha.scss": 1497,
	"./shared/hide-donate-links.scss": 1498,
	"./shared/intl-tel-input.scss": 1499,
	"./shared/mailing-list-form.scss": 1500,
	"./shared/mailing-list-sign-up-button.scss": 1501,
	"./shared/mobile-donate-banner.scss": 1502,
	"./shared/parsley.scss": 1503,
	"./shared/percy.scss": 1504,
	"./shared/public_campaign_card_details.scss": 1505,
	"./shared/simple-form.scss": 1506,
	"./shared/sly-quiz.scss": 1507,
	"./shared/spring_logo_svg.scss": 1508,
	"./shared/spring_mark_svg.scss": 1509,
	"./shared/spring_series_seasons.scss": 1510,
	"./shared/video-box-container.scss": 1511,
	"./tailwinds.scss": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1332;